export default class CollapseToggleController {
  handleToggle (id) {
    if (id) {
      this.onToggle({ id })
    } else {
      this.onToggle()
    }
  }
}
